interface ProgressBarProps {
  progressPercentage: number;
}

const ProgressBar = ({ progressPercentage }: ProgressBarProps) => {
  return (
    <div className="h-2 w-full rounded-sm bg-primary-50">
      <div
        className={`h-2 rounded-sm bg-primary-200`}
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );
};

export default ProgressBar;
